import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// Оставили только BlockMath для главной формулы
import { BlockMath } from 'react-katex';

import SEO from '../../../seo';

const FormulasRead = ({ formula, categoryId, onClose }) => {
    const { t } = useTranslation();

    // Блокируем скролл основной страницы, когда модалка открыта
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);

    if (!formula) return null;

    return (
        <div className="read_formula_back_overlay" onClick={onClose}>

            <SEO>
                {/* Формат: Физика: Название формулы */}
                <title>{`${t('translate.app_name2')}: ${formula.content.formulaName}`}</title>
            </SEO>

            {/* e.stopPropagation() не дает закрыть модалку при клике внутри белого окна */}
            <div className="formula-krasivo-modal" onClick={(e) => e.stopPropagation()}>

                <button className="formula-krasivo-modal__close" onClick={onClose}>×</button>

                <div className="formula-krasivo-modal__content">
                    {/* Верхний блок с крупной формулой на цветном фоне */}
                    <div className={`formula-krasivo-modal__latex-viewww formula-krasivo-modal__latex-viewww--${categoryId || 0}`}>
                        {formula.content.formula ? (
                            <BlockMath math={formula.content.formula} />
                        ) : (
                            <span>Формула отсутствует</span>
                        )}
                    </div>

                    <h2 className="formula-krasivo-modal__zagolovok">{formula.content.formulaName}</h2>
                    <p className="formula-krasivo-modal__description">{formula.content.description}</p>

                    {/* Список переменных отображается простым текстом */}
                    {formula.content.variables && formula.content.variables.length > 0 && (
                        <div className="formula-krasivo-modal__variables">
                            <h4>{t('translate.read_title_variable') || 'Переменные:'}</h4>
                            <ul>
                                {formula.content.variables.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FormulasRead;